import './_styles.scss';
import React from 'react';
import _Image from 'assets/placeholder.svg';

export default () => {

  const Image = { backgroundImage: `url(${_Image})` };

  return (
    <div className='Item-Card Skeleton'>

      <div className="Content Item-Image" style={Image}/>

      <div className="Item-Content">
        <div className='Content Row-1'/>
        <div className="Content Row-2 P1"/>
        <div className="Content Row-2 P2"/>
        <div className="Content Row-2 P3"/>
        <div className="Content Row-3"/>
      </div>

    </div>
  )
}
